import React from 'react'
import { connect } from "react-redux";
import { verfiyMobileLogin } from "../store/actions/auth";
import { showLoader, hideLoader } from '../store/actions/loader';
import { AlertJsMessage } from './../helpers.js'
class ValidateMobileLogin extends React.Component {

  componentDidMount() {
  }

  
  render() {
    return (
      <div className="container mobile-exercise">
        <div className="row">
          <div className="content-box video-popup">
            <div className="col-md-10 col-md-offset-1">
              <div className="content">
                <h1>There is some error while we are logging in to your account. Please close the application and relaunch it again. <span role="img" aria-label="content">&#128522;</span></h1>
                <img src={"/assets/img/logo.png"} alt="Fitbanx_logo" style={{ display: "block", marginLeft: "auto", marginRight: "auto", width: "50%" }} />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.currentUser.user,
    payments: []
  }
}
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    verfiyMobileLogin: (token) => dispatch(verfiyMobileLogin(token)),
    showLoader: () => dispatch(showLoader()),
    hideLoader: () => dispatch(hideLoader())
  }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(ValidateMobileLogin);



// WEBPACK FOOTER //
// ./src/components/authenticationError.js